import OrderCargoOrderFinishedDownloadRequest, {
  OrderCargoOrderFinishedDownloadRequestQueryParams,
} from "./order-cargo-order-finished-download-request";

const createQueryParams = (
  data: OrderCargoOrderFinishedDownloadRequest,
): OrderCargoOrderFinishedDownloadRequestQueryParams => {
  return {
    client: data.client,
    dispatch: data.dispatch,
    driver: data.driver,
    passenger: data.passenger,
    taxi: data.taxi,
    externalId: data.externalId,
    isApproved: data.isApproved,
    isCancelled: data.isCancelled,
    address: data.address,
    startAddress: data.startAddress,
    midAddress: data.midAddress,
    endAddress: data.endAddress,
    publicStatus: data.publicStatus,
    order: data.order,
    startTimeSince: data.startTimeSince,
    startTimeTo: data.startTimeTo,
    humanId: data.internalOrderId,
  };
};

const orderCargoOrderFinishedListReportRequestFactory = {
  createQueryParams,
};

export default orderCargoOrderFinishedListReportRequestFactory;
